<template>
  <v-container>
    <v-row justify="center">
      <v-col :lg="6" :md="8" :sm="10" :xs="12">
        <v-card class="pa-4">
          <v-select :items="dates" label="Day" solo v-model="date">
            <template v-slot:item="{ item }">{{ formattedDate(item) }}</template>
            <template v-slot:selection="{ item }">
              {{
              formattedDate(item)
              }}
            </template>
          </v-select>
          <v-row>
            <v-col cols="4">
              <v-subheader>Name</v-subheader>
            </v-col>
            <v-col cols="4">
              <v-subheader style="font-weight: bold; color: green;">AM</v-subheader>
            </v-col>
            <v-col cols="4">
              <v-subheader style="font-weight: bold; color: orange">PM</v-subheader>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-progress-linear class="ma-0 pa-0" indeterminate color="cyan" v-if="loading"></v-progress-linear>

          <v-subheader>Your availability</v-subheader>
          <v-card width="100%" tile>
            <v-row>
              <v-col class="mt-5 ml-4">{{ currentUser.name }}</v-col>
              <v-col>
                <v-checkbox v-model="currentUser.am" @change="updateAvailibility"></v-checkbox>
              </v-col>
              <v-col>
                <v-checkbox v-model="currentUser.pm" @change="updateAvailibility"></v-checkbox>
              </v-col>
            </v-row>
          </v-card>

          <v-subheader>Everyone else</v-subheader>

          <v-card v-for="(user, index) in users" :key="index" width="100%" tile>
            <v-row>
              <v-col class="mt-5 ml-4">{{ user.name }}</v-col>
              <v-col>
                <v-checkbox v-model="user.am" readonly></v-checkbox>
              </v-col>
              <v-col>
                <v-checkbox v-model="user.pm" readonly></v-checkbox>
              </v-col>
            </v-row>
          </v-card>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import * as moment from "moment";

export default {
  name: "timetable",

  data() {
    return {
      currentUser: {
        id: "",
        name: "",
        am: false,
        pm: false
      },
      week: null,
      date: null
    };
  },

  methods: {
    ...mapActions({
      fetchUsers: "availability/fetchUsers",
      updateUser: "availability/updateAvailability"
    }),

    formattedDate(date) {
      return moment(date).format("dddd DD.MM.YY");
    },

    fetchUsersForDate(date) {
      this.fetchUsers(date);
    },

    updateAvailibility() {
      var payload = {
        ...this.currentUser,
        date: moment(this.date, "DD.MM.YY"),
        week: moment(this.date, "DD.MM.YY").isoWeek()
      };

      this.updateUser(payload);
    }
  },

  computed: {
    ...mapState({
      availability: state => state.availability,
      auth: state => state.auth
    }),

    loading() {
      return this.availability.loading;
    },

    allUsers() {
      return this.availability.users;
    },

    users() {
      return this.allUsers.filter(user => {
        return user.id != this.currentUser.id;
      });
    },

    apiUser() {
      return this.auth.user;
    },

    dates() {
      const days = [];
      for (let i = 0; i <= 14; i++) {
        days.push(moment().add(i, "days"));
      }
      return days;
    }
  },

  mounted() {
    this.currentUser.id = this.apiUser.id;
    this.currentUser.name = this.apiUser.name;

    this.date = this.dates[0];
  },

  watch: {
    date(val) {
      this.fetchUsersForDate(moment(val).format("DD.MM.YY"));
    },
    allUsers() {
      let currentUser = this.allUsers.find(user => {
        return user.id == this.currentUser.id;
      });

      if (currentUser) {
        this.currentUser.am = currentUser.am;
        this.currentUser.pm = currentUser.pm;
      } else {
        this.currentUser.am = false;
        this.currentUser.pm = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
